export default "__VITE_ASSET__J88p3wwM__"